// extracted by mini-css-extract-plugin
module.exports = {"button":"Button-module--button--2mvQU","icon":"Button-module--icon--379Jd","center":"Button-module--center--29q-p","default":"Button-module--default--HNN96"};